import { IconColorPalette, IconSettings, IconSymbolLibrary } from '@lib/icons'
import type { ArtBoardMode } from '@store/reducers/artboard/types'
import type { ReactNode } from 'react'

import { GtmTriggerName } from '@/constants/gtm'
import { useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'

export type SidebarTab = {
  mode: ArtBoardMode
  icon: ReactNode
  title: string
  tooltip: string
  badge?: string | null
  visible: boolean
  disabled: boolean
  gtmProBadgeEvent?: GtmTriggerName
}

export const useGetSidebarSwitcher = (): SidebarTab[] => {
  const {
    hasNotAvailableAccessBadge: hasAccessColorLibraryNABadge,
    badgeType: colorLibraryBadgeType,
  } = useProjectAccess(PROJECT_SETTINGS_PERMISSION.COLOR_LIBRARY_TAB)

  const badge = hasAccessColorLibraryNABadge ? colorLibraryBadgeType : null

  return [
    {
      mode: 'settings',
      icon: <IconSettings />,
      title: 'Project settings',
      tooltip: 'Settings',
      badge: null,
      visible: true,
      disabled: false,
    },
    {
      mode: 'color',
      icon: <IconColorPalette />,
      title: 'Colors',
      tooltip: 'Colors',
      visible: true,
      badge,
      disabled: hasAccessColorLibraryNABadge,
      gtmProBadgeEvent: GtmTriggerName.UPGRADE_COLORS,
    },
    {
      mode: 'symbol_library',
      icon: <IconSymbolLibrary size={20} />,
      title: 'Symbols',
      tooltip: 'Symbols',
      visible: true,
      badge,
      disabled: hasAccessColorLibraryNABadge,
      gtmProBadgeEvent: GtmTriggerName.UPGRADE_SYMBOLS,
    },
  ]
}
